module.exports = __webpack_public_path__ + "static/media/googleplay-zh-CN.f7c7938f.png";